import { type FC } from "react";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { type InvoiceInfoData } from "~/domains/orders/types/models";

const Tracker: FC<{ data: InvoiceInfoData }> = (props) => {
  const haveTrackingUrl = props.data.trackingUrl && props.data.trackingUrl !== "-" && props.data.trackingUrl !== "";
  const divTrack = (
    <div className="scha__order-table__tracker__link d-flex flex-align-center">
      <Icon type={IconType.Location} className={"scha__order-table__tracker__icon"} />
      {props.data.trackingNo}
    </div>
  );

  return (
    <div className="scha__order-table__tracker">
      <div className="scha__order-table__tracker__type">
        {props.data.shippingPartnerName &&
        props.data.shippingPartnerName !== "-" &&
        props.data.shippingPartnerName !== ""
          ? props.data.shippingPartnerName
          : props.data.shippingPartnerId}
      </div>
      {props.data.trackingNo && props.data.trackingNo !== "-" && (
        <>
          {haveTrackingUrl ? (
            <a href={props.data.trackingUrl} target="_blank">
              {divTrack}
            </a>
          ) : (
            <>{divTrack}</>
          )}
        </>
      )}
    </div>
  );
};

export default Tracker;
